<ng-container *ngIf="input">
	<div [ngSwitch]="input.templateName">
		<app-dft-single-column *ngSwitchCase="'Single Column Form'" [title]="title" [dynamicForm]="input" [callback]="result"></app-dft-single-column>
		<app-dft-dual-column *ngSwitchCase="'Dual Column Form'" [title]="title" [dynamicForm]="input" [callback]="result"></app-dft-dual-column>
		<app-dft-single-column *ngSwitchDefault [title]="title" [dynamicForm]="input" [callback]="result"></app-dft-single-column>
	</div>
</ng-container>
